<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th>Kode BAST</th>
                        <th>Jumlah</th>
                        <th>Tanggal Pengiriman</th>
                        <th>Status</th>
                        <th>Tanggal Penerimaan</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data" v-for="(dat, index) in data">
                        <td>{{ dat.bast_no ? dat.bast_no : '-' }}</td>
                        <td>{{ dat.qty ? numberWithCommas(dat.qty) : '-' }}</td>
                        <td>{{ dat.delivery_at ? moment(dat.delivery_at).format('DD MMM YYYY | HH:mm') : '-' }}</td>
                        <td>{{ dat.status == 'RECEIVED' ? 'Received' : 'In-Transit' }}</td>
                        <td>{{ dat.received_at ? moment(dat.received_at).format('DD MMM YYYY | HH:mm') : '-' }}</td>
                    </tr>
                    <tr v-else-if="data && !data.length">
                        <td colspan="5">No data</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+data.length }} of {{ config.total }} items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import debounce from 'debounce';

    export default {
        props: {
            // Dealer accounts see only shipments received from MD, matching the
            // Main Dealer tab of Penerimaan QR; POS accounts keep the full list.
            excludeChild: {
                type: Boolean,
                default: false,
            },
            search: {
                type: String,
                default: '',
            },
            startDate: {
                type: String,
                default: '',
            },
            endDate: {
                type: String,
                default: '',
            },
        },
        data () {
            return {
                moment: moment,
                data : null,
                filter : {
                    start_date: this.startDate,
                    end_date: this.endDate,
                    status: 'RECEIVED',
                    search: '',
                },
                config : {
                    page: 1,
                    limit: 10,
                    lastPage: 0,
                    total: 0,
                },
            }
        },
        mounted () {
            this.fetchPaginated();
        },
        watch : {
            search (value) {
                this.setSearchFilter(value, this);
            },
            startDate (value) {
                this.filter.start_date = value;
            },
            endDate (value) {
                this.filter.end_date = value;
            },
            'filter' : {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.fetchPaginated();
                },
            },
            'config.page' : {
                deep: true,
                handler: 'fetchPaginated'
            }
        },
        methods : {
            goToPage(page) {
                if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
            },
            setSearchFilter: debounce((value, vm) => {
                vm.filter.search = value ? value.trim() : '';
            }, 400),
            fetchPaginated () {
                let filter = JSON.parse(JSON.stringify(this.filter));
                if (this.excludeChild) filter.exclude_child = 1;

                this.$http.get(`/api/qrs/issue`, {params: {...filter, ...{page: this.config.page, limit: this.config.limit}}})
                .then(async res => {
                    let data = res.data.data;
                    this.data = data;

                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;
                })
                .catch((err)=>console.log(err));
            },
        }
    }
</script>

<style scoped>
    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 8px 16px;
        height: 50px;
        vertical-align: middle;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 8px 16px;
        border-bottom: 1px solid #F3F3F3;
        height: 50px;
        vertical-align: middle;
    }
</style>